var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "DeleteBtn",
      on: {
        click: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.$emit("click")
        }
      }
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "btn__reset" }, [
      _c("i", { staticClass: "icon-close_bold" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }